<template>
  <f7-block>
    <f7-row>
      <f7-col width="50">
        <f7-block v-if="!loadedIrrigation">
          <div class="loadingFalse">
            <div class="preloader" />
          </div>
        </f7-block>
        <f7-block v-else>
          <IrrigationComponent />
        </f7-block>
      </f7-col>
      <f7-col width="50">
        <f7-block v-if="!loadedGIS">
          <div class="loadingFalse">
            <div class="preloader" />
          </div>
        </f7-block>
        <f7-block v-else>
          <GISWMSMap
            :zoom="zoom"
            :name-map="mainMap"
            :layer="layer"
            :index="'NDMI'"
            :center="center"
            :height="'450px'"
          />
        </f7-block>
      </f7-col>
    </f7-row>
  </f7-block>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import GISWMSMap from '../../Gis/GISWMSMap/index.vue';
import IrrigationComponent from '../../irrigation/index.vue';
import Api from '../../../services/Api';

export default {
  name: 'Irrigation',
  components: {
    GISWMSMap,
    IrrigationComponent,
  },
  data() {
    return {
      loadedGIS: false,
      loadedIrrigation: false,
      zoom: 17,
      mainMap: 'irrigation',
      layer: {
        name: 'irrigation',
        visible: false,
        timeDimension: true,
        baseUrl: Api.getGeoServerTimacagro(),
        options: {
          layers: '',
          format: 'image/png',
          transparent: true,
          styles: '',
        },
      },
      center: {},
    };
  },
  computed: {
    ...mapState('Plantation', ['currentPlantation', 'treeLocations']),
  },
  async beforeMount() {
    try {
      this.setIdPlantation(this.currentPlantation.id);
      this.setIdCompany(this.currentPlantation.companyId);
      this.setIdPlantationTask(this.currentPlantation.id);
      this.setIdCompanyTask(this.currentPlantation.companyId);
      this.loadedIrrigation = true;
      this.layer.options.layers = `client_efemis:${this.currentPlantation.sectorId}`;
      this.center = { ...this.currentPlantation.coordinates };
      await this.fetchLocationsByPlantation();
      this.loadedGIS = true;
    } catch (error) {
      this.$f7.dialog.alert(this.$t(`${error}`));
    }
  },
  methods: {
    ...mapActions('Plantation', ['fetchLocationsByPlantation']),
    ...mapActions('Irrigation', ['setIdPlantation', 'setIdCompany']),
    ...mapActions('TaskByCompany', ['setIdPlantationTask', 'setIdCompanyTask']),
  },
};
</script>

<style lang="scss" scoped>
@import './Irrigation.styles.scss';
</style>
